import React from 'react';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Skeleton from '@material-ui/lab/Skeleton';

export default function ArticleSkeleton(props) {

    const { isMobile } = props

    return (
        <Grid container spacing={3} wrap={isMobile ? 'wrap' : 'nowrap'}>
            <Grid item sm={12} md={4} style={{ width: '100%'}}>
                <Skeleton height={38} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={38} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={38} width="50%" animation="wave" />
            </Grid>
            <Grid item xs={'auto'}>
                <Divider orientation="vertical"/>
            </Grid>
            <Grid item sm={12} md={8} style={{ width: '100%'}}>
                <Skeleton height={32} width="100%" animation="wave" style={{ marginBottom: 32 }}/>
                <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={24} width="80%" animation="wave" style={{ marginBottom: 32 }}/>
                <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={24} width="38%" animation="wave" style={{ marginBottom: 32 }}/>
                <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 6 }}/>
                <Skeleton height={24} width="64%" animation="wave" style={{ marginBottom: 32 }}/>
            </Grid>
        </Grid>
    )
}
